import type { PlanetRoadmapVariant } from '@/components/PlanetRoadmapCTA';

/**
 * Planet Roadmap funnel registry — Bucket 1 "SaaS funnel" pages.
 *
 * Blog posts listed here replace the consulting ContextualServiceCTA with a
 * Planet Roadmap product CTA (planetroadmap.com) in the blog sidebar. A page
 * is either a funnel page or an ads page (consumer-pages.ts), never both.
 *
 * Note: Planet Roadmap's traffic fit on this site is thin — jira-webhooks went
 * to Alert24 (incident) and the team-workflow KBs went to GlitchReplay. Add
 * future agile/PM/sprint content here as it's published.
 */
export const PLANETROADMAP_BLOG_FUNNEL: Record<string, PlanetRoadmapVariant> = {
  // Agile fundamentals → put-it-into-practice pitch (planetroadmap.com/features)
  'what-is-agile-development': 'agile',
};

export function getPlanetRoadmapVariantForBlog(slug: string): PlanetRoadmapVariant | undefined {
  return PLANETROADMAP_BLOG_FUNNEL[slug];
}
